<template>
    <h4 class="mb-4">
        Subscribe
    </h4>

    <p>Subscribe to an affordable plan to receive access to all our teaching material.</p>

    <p>Choose from over 40 series, covering Old & New Testament for 18-month to 18-year-olds.</p>

    <p>Select a language then print or share the lesson.</p>

    <p>
        <a href="/register" class="btn btn-main btn-outline-light btn-lg" title="Subscribe to free trial">
            Register <font-awesome-icon icon="fa-solid fa-arrow-right" />
        </a>
    </p>
</template>

<script>
export default {
    name: "PromoSidebar",
};
</script>
